import { i18n } from '@/lib/i18n';

export const getRatingLabel = (rating: number) => {
  if (rating >= 4.5 && rating <= 5) {
    return i18n.t('excellent');
  }

  if (rating >= 3.5 && rating < 4.5) {
    return i18n.t('good');
  }

  if (rating >= 2.5 && rating < 3.5) {
    return i18n.t('fair');
  }

  if (rating >= 1.5 && rating < 2.5) {
    return i18n.t('needsImprovement');
  }

  if (rating >= 1.0 && rating < 1.5) {
    return i18n.t('poor');
  }
};
